export default __webpack_public_path__ + "static/media/comix-project.d3958d85.png";